import { CareemPlusBG, CPlus } from 'assets/icons';
import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled(CPlus)`
  position: absolute;
  left: 15px;
  top: 20px;
`;

const StyledSpan = styled.span`
  display: flex;
  align-items: center;
`;

const CareemPlusIcon = () => (
  <StyledSpan>
    <CareemPlusBG />
    <StyledIcon />
  </StyledSpan>
);

export default CareemPlusIcon;
